import Image from 'next/image';
import { useLocale } from 'next-intl';
import React from 'react';

import {
    getMoviePosterBlurDataImage,
    getMoviePosterImage,
    getMovieTitle,
    MovieVersionDto
} from '@cineamo/api/helpers/movie-helper';

import { loadAsset } from '@cineamo/ui/src/helpers/asset-helper';
import { cn } from '@cineamo/ui/src/helpers/cn';
import { getLanguageCodeFromString, ISO_3166_1_LOCALE } from '@cineamo/ui/src/helpers/locale-helper';

const moviePlaceholderImage = loadAsset('/images/placeholders/portrait/im-posterFilmWithTitlePortrait.jpg');

export type MoviePosterProps = {
    className?: string;
    movie?: MovieVersionDto;
    countryCode?: ISO_3166_1_LOCALE;
};

export default function MoviePoster(props: MoviePosterProps): React.JSX.Element {
    const { className, movie, countryCode } = props;
    const locale = useLocale();

    const language = getLanguageCodeFromString(locale);

    const imagePath = getMoviePosterImage(movie, { language, countryCode, useBackdropAsFallback: true });
    const blurDataUrl = getMoviePosterBlurDataImage(movie, { language, countryCode, useBackdropAsFallback: true });
    const movieTitle = getMovieTitle(movie, locale, countryCode);

    return (
        <div className={cn(className, 'block relative h-full flex-none')}>
            <Image
                className="w-full h-full object-cover"
                width={200}
                height={300}
                src={imagePath || moviePlaceholderImage}
                placeholder={imagePath ? 'blur' : 'empty'}
                blurDataURL={imagePath ? blurDataUrl : undefined}
                alt={`${movieTitle} poster`}
            />

            {!imagePath && (
                <span
                    className="absolute bottom-0 w-full text-center text-body-bold-12 text-white p-6 break-words whitespace-pre-wrap
                    h-auto select-none">
                    {movieTitle}
                </span>
            )}
        </div>
    );
}
